import { Tooltip } from '@material-ui/core';
import React, { useEffect } from 'react';
import sanitizeHtml from 'sanitize-html';
import { getApprovedIndications } from '../Async/PaymentSchemeAsync';
import { Button, ButtonMode, ButtonVariant } from '../Components/Button';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { StyledDialogAppBar } from '../Components/Dialog/StyledDialogAppBar';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { StyledDialogContent } from '../Components/Dialog/StyledDialogContent';
import { CloseIcon } from '../Components/Icons';
import { LayoutCentral } from '../Components/LayoutCentral';
import { LoadingPlaceholder } from '../Components/Placeholder';
import { useAsync, UseAsyncStatus } from '../Hooks/useAsync';
import { useHttpConfig } from '../Shared/HttpRequestExecutor';
import { white50 } from '../Styles/Colours';
import styles from './ApprovedIndicationsDialog.module.css';
export var ApprovedIndicationsDialog = function (props) {
    var httpConfig = useHttpConfig();
    var pbsDetailsAsync = useAsync({
        getApi: getApprovedIndications,
        httpConfig: httpConfig
    });
    useEffect(function () {
        pbsDetailsAsync.getApi(props.pbsDetailCode);
    }, []);
    var actionButtons = [
        React.createElement(StyledDialogButton, { mode: ButtonMode.solid, variant: ButtonVariant.light, width: 104, key: 'close', testId: 'indications-close', onClick: props.onClose }, "Close")
    ];
    function getContent() {
        if (pbsDetailsAsync.status != UseAsyncStatus.Loaded)
            return (React.createElement(LayoutCentral, null,
                React.createElement(LoadingPlaceholder, null)));
        var indicationData = pbsDetailsAsync.data;
        if (!indicationData ||
            (indicationData.approvedIndications.length === 0 && indicationData.cautions.length === 0)) {
            return React.createElement("div", null, "No Indications found");
        }
        var approvedIndications = indicationData.approvedIndications;
        var cautions = indicationData.cautions;
        return (React.createElement("div", { className: styles.indicationsContent },
            !!cautions.length && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.title }, "Caution"),
                cautions.map(function (caution, index) { return (React.createElement("div", { key: index },
                    React.createElement("div", { className: styles.regular, dangerouslySetInnerHTML: {
                            __html: sanitizeHtml(caution.htmlText)
                        } }))); }))),
            approvedIndications.map(function (indication, index) { return (React.createElement("div", { key: index },
                React.createElement("div", { className: styles.title },
                    React.createElement("span", null,
                        "#",
                        indication.approvedIndicationNumber,
                        " ",
                        indication.approvedIndicationName)),
                React.createElement("div", { className: styles.regular },
                    indication.treatmentPhase && React.createElement("div", null,
                        "Treatment Phase: ",
                        indication.treatmentPhase),
                    React.createElement("div", { dangerouslySetInnerHTML: {
                            __html: sanitizeHtml(indication.htmlText)
                        } })))); })));
    }
    return (React.createElement(StyledDialog, { open: true, size: 'md', modal: true, testId: 'indications-dialog', titleComponent: React.createElement(StyledDialogAppBar, { title: 'Approved indications', titleBarRight: React.createElement(Tooltip, { title: 'Close' },
                React.createElement(Button, { iconOnly: true, onClick: props.onClose, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'close-approved-indications-dialog' },
                    React.createElement(CloseIcon, { size: '20', color: white50, noPadding: true }))) }), actions: actionButtons, contentComponent: React.createElement(StyledDialogContent, { noPadding: true }, getContent()) }));
};
